<template>
	<div class="card">
		<div class="card-header" v-if="$slots.header"><slot name="header"></slot></div>
		<slot name="under-header"></slot>
		<div class="card-body">
			<slot></slot>
		</div>
		<div class="card-footer" v-if="$slots.footer"><slot name="footer"></slot></div>
	</div>
</template>

<script>
	export default {

	}
</script>